import { workerRegistry } from "@/lib/agents/registry"
import { NodeProps } from '@xyflow/react'
import { Flag } from "lucide-react"
import { InlineHandles, WorkerLabeledHandle } from "../handles"
import { useWorker } from "../hooks"
import { NodeLayout } from './node'

const { writeFlags } = workerRegistry

writeFlags.icon = Flag

export function WriteFlagsNode(props: NodeProps) {
  const worker = useWorker<WriteFlagsWorker>(props.id)
  const flagId = worker.parameters?.flag_id

  return (
    <NodeLayout worker={worker}>
      <InlineHandles>
        <WorkerLabeledHandle handler={worker.fields.flag_ids} />
        <WorkerLabeledHandle handler={worker.fields.triggered} />
      </InlineHandles>
      <WorkerLabeledHandle handler={worker.fields.reasoning} />
      <WorkerLabeledHandle handler={worker.fields.tool} />
      {flagId && (
        <p className="text-xs text-center text-muted-foreground mt-2 px-2">
          Flag: <span className="font-medium text-foreground">{flagId}</span>
        </p>
      )}
    </NodeLayout>
  )
}
